import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UsersService} from '../../../users/users.service';
import {SurveyService} from '../../surveys.service';
import {SurveyPermissionModel} from '../../../../models/survey/survey.model';
import {AuthTokenService} from '../../../../shared/services/auth-token.service';

@Component({
  selector: 'app-user-tab',
  templateUrl: './user-tab.component.html',
})
export class UserTabComponent implements OnInit {

  listPermission = [
    {value: 'All', text: 'All Users'},
    {value: 'Admin', text: 'Admin Only'},
    {value: 'User', text: 'Selected Users'}
  ];
  permissionSelected: any;
  listUsers: any[] = [];
  selectedUserIds: number[] = [];
  @Input() surveyId: number;
  isAdmin = AuthTokenService.isAdmin();
  showLoader = false;

  constructor(private userService: UsersService,
              private surveyService: SurveyService) {
  }

  ngOnInit(): void {
    this.userService.getAllBySurvey(this.surveyId)
      .subscribe(users => {
        this.listUsers = users.sort((a, b) => `${a.firstName} ${a.lastName}`.toLowerCase() > `${b.firstName} ${b.lastName}`.toLowerCase() ? 1 : -1);
        this.surveyService.getSurveyPermission(this.surveyId)
          .subscribe(res => {
            this.permissionSelected = res.permission;
            this.selectedUserIds = res.userIds || [];
          });
      });
  }

  onSelectedPermission(event: any) {
    if (event.value !== this.permissionSelected) {
      this.selectedUserIds = [];
    }
    this.permissionSelected = event.value;
  }

  onSelectedUsers(event) {
    this.selectedUserIds = event;
  }

  displayExpr(s) {
    return `${s.firstName} ${s.lastName}`;
  }

  save() {
    this.showLoader = true;
    const surveyPermission = new SurveyPermissionModel();
    surveyPermission.surveyId = this.surveyId;
    surveyPermission.permission = this.permissionSelected;
    surveyPermission.userIds = this.selectedUserIds;
    this.surveyService.updateSurveyPermission(surveyPermission)
      .subscribe(_ => {
        this.showLoader = false;
      }, _ => {
        this.showLoader = false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/new-survey/user-tab/user-tab.component.ts